import {frontendURL} from "../../../../helper/URLHelper";

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: ['settings_account_campaigns', 'one_off', 'online_wa_mass', 'sms_campaigns', 'email_campaigns'],
  menuItems: [
    {
      key: 'waMassCampaigns',
      icon: 'ion-social-whatsapp',
      label: 'ONLINE_WA_MASS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/online_wa_mass`),
      toStateName: 'online_wa_mass',
    },
    {
      key: 'sms_campaigns',
      icon: 'ion-ios-chatboxes',
      label: 'SMS_CAMPAIGNS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/sms_campaigns`),
      toStateName: 'sms_campaigns',
    },
    {
      key: 'email_campaigns',
      icon: 'ion-email',
      label: 'EMAIL_CAMPAIGNS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email_campaigns`),
      toStateName: 'email_campaigns',
    },
  ],
});

export default campaigns;
